import { Component, ViewChild } from '@angular/core';
import { IotaModalSize, MatDialogRef } from '@iota/iota-ui-components';
import { PlatformLicenseFormComponent } from '../../components/platform-license-form/platform-license-form.component';
import { UpsertPlatformLicense } from 'src/app/store/actions/platform-license.actions';
import { Store } from '@ngrx/store';
import { waitForBooleanValue } from '../../utils';
import { platformLicenseActionLoading } from 'src/app/store/reducer/platform-license.reducer';

@Component({
    standalone: false,
    selector: 'app-create-platform-license-dialog',
    templateUrl: './create-platform-license-dialog.component.html',
    styleUrls: ['./create-platform-license-dialog.component.scss']
})
export class CreatePlatformLicenseDialogComponent {
    @ViewChild('platformLicenseForm') platformLicenseForm: PlatformLicenseFormComponent;

    loading$ = this.store.select(platformLicenseActionLoading);

    public modalOptions = {
        size: IotaModalSize.SIZE_7XL
    };
    formValid = false;

    constructor(
        private dialogRef: MatDialogRef<CreatePlatformLicenseDialogComponent>,
        private store: Store
    ) {}

    updateFormValidity(formValid: boolean) {
        this.formValid = formValid;
    }

    async save() {
        const platformLicense = this.platformLicenseForm?.getUpsertedPlatformLicense();
        if (!!platformLicense) {
            this.store.dispatch(UpsertPlatformLicense({ platformLicense }));
        }

        await waitForBooleanValue(this.store, platformLicenseActionLoading, false);
        this.closeDialog();
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
